import React from "react";
/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import { useEffect } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, forwardRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import CouponAdd from "./CouponAdd";
import CouponEdit from "./CouponEdit";
import pr from "../lib/pr";
import { loginState, configState } from "../lib/State";
import token_login from "../lib/token_login";
import get_session from "../lib/get_session";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import { AppBar, Toolbar, IconButton } from "@mui/material";
import CenterSelect from "./CenterSelect";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import get_login from "../lib/get_login";
import is_admin from "../lib/is_admin";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Coupon() {
  const [login, setLogin] = useState(loginState);
  const [loaded, setLoaded] = useState(false);
  const [rows, setRows] = useState([]);
  const [seq, setSeq] = useState(-1);
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const token = localStorage.getItem("token");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [popPhone, setPopPhone] = useState("Hello");
  const [centers, setCenters] = useState([]);
  const [tcid, setTcid] = useState("");

  const open = Boolean(anchorEl);

  // 폼 데이타
  const [data, setData] = useState({
    tcid: "",
    sname: "",
    sphone: "",
  });

  const onHandleData = (e) => {
    setData((state) => {
      return { ...state, [e.target.name]: e.target.value };
    });
  };

  const columns = [
    { field: "id", headerName: "id", hide: true },
    { field: "regdate", headerName: "등록", width: 130, align: "center" },
    {
      field: "mb_name",
      headerName: "이름",
      width: 100,
      align: "center",
      renderCell: (params) => {
        return (
          <Typography
            sx={{ p: 1 }}
            onMouseEnter={(event) =>
              onPopoverOver(event, params.row.mb_phone_format)
            }
            onMouseOut={onPopoverOut}
          >
            {params.row.mb_name}
          </Typography>
        );
      },
    },
    {
      field: "pt_type",
      headerName: "구분",
      width: 90,
      align: "center",      
    },
    {
      field: "pname",
      headerName: "상품명",
      width: 160,     
    },
    { field: "total_amount", headerName: "금액", align: "center", width: 100 },
    { field: "total_count", headerName: "보유", align: "center", width: 70 },
    { field: "use_count", headerName: "사용", align: "center", width: 70 },
    {
      field: "enroll_sdate",
      headerName: "시작일",
      align: "center",
      width: 120,
    },
    {
      field: "enroll_edate",
      headerName: "종료일",
      align: "center",
      width: 120,
    },
    {
      field: "state",
      headerName: "상태",
      width: 90,
      align: "center",
      renderCell: (params) => {
        const color = params.row.state === "Y" ? "#3096F4" : "gray";
        return <LightbulbIcon sx={{ color: color }}></LightbulbIcon>;
      },
    },
    { field: "cname", headerName: "센터명", width: 140, align: "center" },
  ];

  // const rows = [
  //   {
  //     id: 1,
  //     name: "Snow",
  //     phone: "000-0000-0000",
  //     sex: "남",
  //     age: 35,
  //     weight: 55,
  //   }
  // ];

  const onCloseAddPop = () => {
    setShowAdd(false);
    load_data();
  };

  const onCloseEditPop = () => {
    setShowEdit(false);
    load_data();
  };

  const onOpenAdd = () => {
    setShowAdd(true);
  };

  // 리스트
  const load_data = async () => {
    console.log("coupon : load_data");
    let result = await axios.post(configState.api + "/gympass_admin/coupon", {
      token: token,
      cid: login.cid,
      level: login.level,
      mcd: login.mcd,
      tcid: tcid,
      sname: data.sname,
      sphone: data.sphone,
      enroll_edate: data.enroll_edate,
    });
    console.log(result.data);

    if (result.data.success === 1) {
      setRows(result.data.rows);
    } else {
      Swal.fire(result.data.msg);
      return;
    }
  };

  // ======================= //
  // 로그인
  // ======================= //
  const start = async () => {
    let result;
    result = await get_login();
    setLogin(result.data.login);
    result = await is_admin(result.data.login);
    if (!result) {
      window.location.href = "/";
    }
    setLoaded(true);
  };
  useEffect(() => {
    start();
  }, []);

  // 리스트
  useEffect(() => {
    if (loaded && tcid !== "") {
      load_data();
    }
  }, [loaded, tcid]);

  // 팝업처리
  const onPopoverOver = (event, message) => {
    setPopPhone(message);
    setAnchorEl(event.currentTarget);
  };

  const onPopoverOut = (event) => {
    setAnchorEl(null);
  };

  const onSearchClick = () => {
    load_data();
  };

  return (
    <>
      {loaded === false ? (
        <Loading></Loading>
      ) : (
        <Layout login={login}>
          <Popover
            id="mouse-over-popover"
            sx={{
              pointerEvents: "none",
            }}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            onClose={onPopoverOut}
            disableRestoreFocus
          >
            <Typography sx={{ p: 1 }}>{popPhone}</Typography>
          </Popover>

          <h3
            css={css`
              margin-top: 10px;
            `}
          >
            쿠폰관리
          </h3>

          <Box
            display="flex"
            css={css`
              text-align: right;
              max-width: 1300px;
              margin-bottom: 15px;
            `}
          >
            {/* 센터명 */}
            <CenterSelect
              login={login}
              tcidParent={tcid}
              setTcidParent={setTcid}
            />
          </Box>

          <Box display="flex" sx={{ mb: 1 }}>
            {/* 이름 */}
            <Box>
              <TextField
                sx={{ width: 120 }}
                name="sname"
                label="이름"
                size="small"
                onChange={onHandleData}
                autoComplete="off"
              ></TextField>
            </Box>

            {/* 연락처 */}
            <Box>
              <TextField
                sx={{ width: 160, ml: 1 }}
                name="sphone"
                label="연락처"
                size="small"
                onChange={onHandleData}
                autoComplete="off"
              ></TextField>
            </Box>
            <Box>
              <TextField
                sx={{ width: 160, ml: 1 }}
                name="enroll_edate"
                label="종료일"
                size="small"
                onChange={onHandleData}
                autoComplete="off"
              ></TextField>
            </Box>
            <Button
              sx={{ ml: 1, fontSize: 15 }}
              variant="contained"
              onClick={onSearchClick}
              size="small"
            >
              조회
            </Button>
          </Box>

          <DataGrid
            css={css`
              max-width: 1300px;
              min-height: 550px;
            `}
            rows={rows}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[5]}
            checkboxSelection={false}
            onRowClick={(params) => {
              setSeq(params.row.id);
              setShowEdit(true);
            }}
            components={{ Toolbar: GridToolbar }}
          />

          {/* 수정하기 팝업 */}
          <Dialog
            open={showEdit}
            TransitionComponent={Transition}
            onClose={() => {}}
            maxWidth="lg"
          >
            <AppBar sx={{ position: "static" }}>
              <Toolbar>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography style={{ fontSize: 18 }}>쿠폰수정</Typography>
                </Box>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={onCloseEditPop}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Toolbar>
            </AppBar>
            <CouponEdit
              login={login}
              seq={seq}
              onClosePop={onCloseEditPop}
            ></CouponEdit>
          </Dialog>
        </Layout>
      )}
    </>
  );
}

export default Coupon;
